export const PARTS_COLORS = [
  "#FF6F61",
  "#6B5B95",
  "#88B04B",
  "#F7CAC9",
  "#92A8D1",
  "#955251",
  "#B565A7",
  "#009B77",
  "#DD4124",
  "#D65076",
  "#45B8AC",
  "#EFC050",
  "#5B5EA6",
  "#9B2335",
  "#DFCFBE",
  "#55B4B0",
  "#E15D44",
  "#7FCDCD",
  "#BC243C",
  "#C3447A",
];

export const WELCOME_PARTS = [
  { id: "1", name: "Welcome", color: PARTS_COLORS[13], weight: 1 },
  { id: "2", name: "To", color: PARTS_COLORS[18], weight: 1 },
  { id: "3", name: "Who", color: PARTS_COLORS[8], weight: 1 },
  { id: "4", name: "Pays ?", color: PARTS_COLORS[16], weight: 1 },
];

export const FORTUNE_WHEEL_CONSTANTS = {
  wheelRadius: 210,
  wheelOuterShadowWidth: 5,
  wheelInnerShadowWidth: 5,
  wheelOuterShadowColor: "rgba(0, 0, 0, 0.2)",
  wheelInnerShadowColor: "rgba(255, 255, 255, 0.5)",
  wheelOuterLineWidth: 8,
  wheelInnerLineWidth: 4,
  wheelInnerLineColor: "black",
  wheelOuterLineColor: "black",
  wheelInnerCenterDotColor: "black",
  wheelOuterCenterDotColor: "brown",
  wheelTurnsPerSecond: 2, // in turns per second
  wheelFirstLinearDuration: 3, // in seconds
  wheelFirstEaseOutDuration: 2, // in seconds
  wheelSecondLinearDuration: 1, // in seconds
  wheelSecondEaseOutDuration: 2, // in seconds
};
